import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { withDevtools } from './middleware-utils';

export interface PendingPaymentOrder {
  id: string;
  amountCents: number;
  recipientName: string;
  concept: string;
  createdAt: string;
}

interface PendingPaymentOrdersStore {
  orders: PendingPaymentOrder[];
  add: (order: PendingPaymentOrder) => void;
  remove: (id: string) => void;
  clear: () => void;
}

export const usePendingPaymentOrdersStore = create<PendingPaymentOrdersStore>()(
  withDevtools(
    'PendingPaymentOrders',
    persist(
      set => ({
        orders: [],
        add: order =>
          set(state => {
            if (state.orders.some(o => o.id === order.id)) return state;
            return { orders: [...state.orders, order] };
          }),
        remove: id =>
          set(state => ({
            orders: state.orders.filter(o => o.id !== id),
          })),
        clear: () => set({ orders: [] }),
      }),
      {
        name: 'tankef:pending-payment-orders',
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);
